import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { compose } from 'redux';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPaperPlane, faPlus } from "@fortawesome/free-solid-svg-icons";

class NewChatMenu extends Component {

    constructor(props) {
        super(props);

        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {

        document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside(e) {
        if (this.props.show && this.wrapperRef && !this.wrapperRef.current.contains(e.target) && !this.props.invoker.current.contains(e.target)) {
            this.props.toggleChat();
        }
    }

    render() {
        return (
            <div ref={this.wrapperRef} className='position-absolute' style={{ right: "10px" }}>
                <div style={{ transform: "none" }} className={"position-relative menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-color py-4 fs-6 w-175px " + (this.props.show ? "show" : "")} >
                    <div className="menu-item px-5">
                        <a href='/' onClick={this.props.toggleNewEmail} className="menu-link px-4">
                            <span><FontAwesomeIcon icon={faEnvelope} /> {this.props.t("newemail")}</span>
                        </a>
                    </div>
                    <div className="menu-item px-5">
                        <a href='/' onClick={this.props.toggleOugoingChatsModal} className="menu-link px-4">
                            <span><FontAwesomeIcon icon={faPaperPlane} /> {this.props.t("outgoingchat")}</span>
                        </a>
                    </div>
                    <div className="menu-item px-5">
                        <a href='/' onClick={this.props.toggleInternalChatModal} className="menu-link px-4">
                            <span><FontAwesomeIcon icon={faPlus} /> {this.props.t("internalchat")}</span>
                        </a>
                    </div>
                </div>
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    return {
    };
};
export default compose(connect(mapStateToProps), withTranslation())(NewChatMenu);